import Image from 'next/image';

import styles from './ReferFriendStep.module.scss';

export interface ReferFriendStepProps {
  imageSrc: string;
  stepNumber: number;
  description: string;
}

export const ReferFriendStep = ({ imageSrc, stepNumber, description }: ReferFriendStepProps) => (
  <div className={styles.step}>
    <Image
      src={imageSrc}
      alt=""
      aria-hidden="true"
      width={449}
      height={244}
      style={{
        maxWidth: '100%',
        height: 'auto',
      }}
    />
    <div className={styles.content}>
      <p className={styles.stepNumber}>Step {stepNumber}</p>
      <p className={styles.description}>{description}</p>
    </div>
  </div>
);
